import React from 'react';
import { useTour } from '@/hooks/useTour';
import { TourStep } from './TourStep';
import { TOUR_STEPS } from './tourSteps';
import { Role } from '@/types/auth';

export const TourOverlay: React.FC = () => {
  const { isActive, currentStep, skipTour, nextStep, prevStep } = useTour();
  
  // Temporary hardcode role for demonstration
  const role = Role.ADMIN;
  const steps = TOUR_STEPS[role] || [];
  const activeStep = steps[currentStep];

  if (!isActive || !activeStep) return null;

  return (
    <div className="fixed inset-0 z-[55] pointer-events-none flex items-center justify-center">
      {/* Background Mask */}
      <div className="absolute inset-0 bg-surface/80 backdrop-blur-sm pointer-events-auto transition-all duration-300" />
      
      {/* The Tooltip content */}
      <TourStep 
        title={activeStep.title}
        content={activeStep.content}
        placement={activeStep.placement}
        currentStep={currentStep}
        totalSteps={steps.length}
        onNext={() => {
          if (currentStep >= steps.length - 1) skipTour();
          else nextStep();
        }}
        onPrev={prevStep}
        onSkip={skipTour}
      />
    </div>
  );
};
